// TODO: NULL-SAFETY - Function doesn't handle empty strings or strings with only whitespace characters - name.split(/[\s-]/) can create empty string elements that cause .map((name) => name[0]) to access index 0 of empty string, returning undefined
export const getInitialsFromName = (name: string) =>
    name
        .split(/[\s-]/)
        .map((name) => name[0])
        .join('');
